<template>
    <Teleport to="body">
        <div
            v-if="showed"
            :class="{'modal fade show': true}"
            :style="{'display': 'block', 'z-index': zIndexModal}"
            @scroll="emitter.emit('modal-scroll')"
        >
            <div :class="['modal-dialog', `modal-${currentSize}`, 'modal-dialog-scrollable']">
                <div class="modal-content">
                    <div class="modal-header pb-3 bg-white align-items-center">
                        <div>
                            <h6 class="modal-title" v-html="title"></h6>
                            <span class="text-muted">{{ $t('stepModal.stepCounter', { current: activeIndex + 1, total: steps.length }) + currentDescription }}</span>
                        </div>
                        <div>
                            <button type="button" class="close" @click="hide">×</button>
                        </div>
                    </div>
                    <div class="modal-body" style="overflow-y: hidden; display: flex; flex-direction: column;">
                        <div class="text-center m-3" v-if="isLoading">
                            <i class="icon-spinner2 spinner mr-2"></i>
                        </div>
                        <template v-for="(step, i) in steps" :key="i">
                            <div :style="i !== activeIndex || isLoading ? 'display: none;' : 'flex: 1; min-height: 0; display: flex; flex-direction: column;'">
                                <component
                                    :is="step.component"
                                    v-bind="step.props"
                                    :ref="el => setStepRef(el, i)"
                                    @update:isReadyForNext="(val) => { if (i === activeIndex) isReadyForNext = val }"
                                />
                            </div>
                        </template>
                    </div>
                    <div class="modal-footer">
                        <button
                            type="button"
                            class="btn btn-light"
                            :disabled="isLoading"
                            @click="activeIndex === 0 ? hide() : clickPrevious()"
                        >
                            {{ activeIndex === 0 ? $t('wizardForm.cancel') : $t('wizardForm.previous') }}
                        </button>
                        <button
                            v-if="activeIndex < steps.length - 1"
                            type="button"
                            class="btn btn-primary"
                            :disabled="!isReadyForNext || isLoading"
                            @click="clickNext"
                        >
                            {{ $t('wizardForm.next') }}
                        </button>
                        <button
                            v-else
                            type="button"
                            class="btn btn-primary"
                            :disabled="!isReadyForNext || isLoading"
                            @click="clickSubmit"
                        >
                            {{ $t('wizardForm.submit') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-backdrop fade show" v-if="showed" :style="{'z-index': zIndexBackdrop}"></div>
    </Teleport>
</template>
<script>
export default {
    name: "StepModal",
    emits: ['submit', 'on-hide', 'update:activeIndex'],
    props: {
        title: {
            type: String,
            required: true
        },
        steps: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            activeIndex: 0,
            done: [],
            stepRefs: [],
            isReadyForNext: false,
            isLoading: false,
            scrollbar: null,
            showed: false,
            modalCount: 0,
            zIndexModal: 1015,
            zIndexBackdrop: 1010
        };
    },
    computed: {
        currentSize() {
            return this.steps[this.activeIndex]?.size ?? '';
        },
        currentDescription() {
            return this.steps[this.activeIndex]?.description ?? '';
        }
    },
    methods: {
        show() {
            if (this.showed === true) {
                return;
            }

            this.refreshIsReadyForNext();

            this.modalCount = document.getElementsByClassName('modal-backdrop').length
            this.zIndexBackdrop = 1000 + ((this.modalCount + 1) * 10)
            this.zIndexModal = this.zIndexBackdrop + 5

            this.showed = true;
        },
        hide() {
            if (this.showed === false) {
                return;
            }

            this.showed = false;
            this.$emit('on-hide')
        },
        reset() {
            this.activeIndex = 0;
            this.done = [];
            this.isLoading = false;
            this.isReadyForNext = false;
            this.$emit('update:activeIndex', 0);
        },
        setStepRef(el, index) {
            if (el) {
                this.stepRefs[index] = el;
            }
        },
        clickNext() {
            this.done[this.activeIndex] = true;
            if (this.activeIndex < this.steps.length - 1) {
                this.activeIndex++;
                this.$emit('update:activeIndex', this.activeIndex);
                this.refreshIsReadyForNext();
                this.notifyStepActivated();
            }
        },
        clickPrevious() {
            if (this.activeIndex > 0) {
                this.activeIndex--;
                this.$emit('update:activeIndex', this.activeIndex);
                this.refreshIsReadyForNext();
                this.notifyStepActivated();
            }
        },
        clickSubmit() {
            if (!this.isReadyForNext) return;

            this.isLoading = true;
            this.$emit('submit');
        },
        refreshIsReadyForNext() {
            const currentStep = this.stepRefs[this.activeIndex];

            if (currentStep && typeof currentStep.isReadyForNext === 'boolean') {
                this.isReadyForNext = currentStep.isReadyForNext;
                return;
            }

            this.isReadyForNext = true;
        },
        notifyStepActivated() {
            const step = this.stepRefs[this.activeIndex];
            if (step && typeof step.onActivate === 'function') {
                step.onActivate();
            }
        }
    },
    watch: {
        showed(newVal) {
            let modelCount = document.getElementsByClassName('modal-backdrop').length;

            if (newVal && modelCount === 0) {
                document.body.style.overflowY = 'hidden';
            } else if (!newVal && modelCount === 1) {
                document.body.style.overflowY = 'auto';
            }
        }
    }
}
</script>
<style>
.modal-footer:not([class*=bg-]) {
    padding-top: 1.25rem;
    border-top-width: 1px;
}
</style>
